import React from 'react';
import {Accordion, Icon, List, Menu, Sidebar} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {MainMenu, mycdp_uri, SubMenu} from '../constants';
import Logo from '../styles/images/logoMain.png';
import {Account} from "../model/user";
import {useActions} from '../redux/actions';
import * as appActions from '../redux/actions/app';
import {menusArray} from '../menus';
import {v4 as uuidv4} from 'uuid';

interface Props {
  visible: boolean,
  user: Account
}

export default function SideBarMain(props:Props) {
  const parseLeftMenuPath = (menu:string) => `/${menu.toLowerCase().split(' ').join('-')}`;
  const appAction = useActions(appActions);
  const {user, visible} = props;
  let basePath = window.location.pathname.split('/')[1];
  basePath = basePath.indexOf('-') > -1
    ? basePath.split('-').join(' ')
    : basePath;
  const basePathIndex = basePath
    ? menusArray.findIndex(i => (i.name || i.title).toLowerCase() === basePath.toLowerCase())
    : -1;

  const closeSideBar = () => {
    appAction.SidebarOpen(false)
  }
  let panels:any;

    panels = menusArray.map((menu: MainMenu, i) => {
      
      // Check if role is assign for menu
      if (menu.role && menu.role.length) {
        let roleExist = false;
        menu.role.forEach((role: string) => {
          if (user.role.indexOf(role.toLowerCase()) >= 0) {
            roleExist = true;
          }
        });
        if (!roleExist) {
          return {key: `panel-${i}`};
        }
      }
      
      const parentLink = `${parseLeftMenuPath(menu.name)}`;
      
      // Child Menu
      if (menu.subMenus && menu.subMenus.length > 0) {
        const childMenus = menu.subMenus.map((subMenu: SubMenu, j: number) => {
          
          // Dont show in menu bar if menu hide is set
          if (subMenu.hide) {
            return true;
          }

          // Check if role is assign for menu
          if (subMenu.role && subMenu.role.length) {
            let roleExist = false;
            subMenu.role.forEach((role: string) => {
              if(user.role.indexOf(role.toLowerCase()) >= 0) {
                roleExist = true;
              }
            });
            if (!roleExist) {
              return false;
            }
          }
          let childPath = window.location.pathname.split('/')[2];
          childPath = childPath && childPath.indexOf('-') > -1
            ? childPath.split('-').join(' ')
            : childPath;
          const childLink = `${parentLink}${parseLeftMenuPath(subMenu.name)}`;
          
          return (
            <List.Item
              key={uuidv4()}
              className={(childPath === subMenu.name.toLowerCase()) ? 'active' : ''}
            >
              <Link
                to={childLink}
                onClick={closeSideBar}
                className={(childPath === subMenu.name.toLowerCase()) ? 'active' : ''}
              >
                {subMenu.customIcon ? <i aria-hidden="true" className={`${subMenu.customIcon}  icon`}/> :
                  <Icon name={subMenu.icon}/>}
                {subMenu.title}
              </Link>
            </List.Item>
          );
        });
        return {
          key: `panel-${i}`,
          title: {
            content: (<span  className={(basePath === menu.name.toLowerCase()) ? 'parentActive' : ''}>
        {menu.customIcon ? <i aria-hidden="true" className={`${menu.customIcon}  icon`}/> :
          <Icon name={menu.icon}/>}
              {menu.title}
              <Icon
                name={(i === basePathIndex) ? 'angle up' : 'angle down'}
              />
      </span>)
          },
          content: {
            content: (<List  >{childMenus}</List>)
          }
        };
      }

      // Don't show in menu bar if menu hide is set
      if (menu.hide) {
        return {key: `panel-${i}`};
      }
      return {
        key: `panel-${i}`,
        title: {
          content: <Link
            onClick={() =>{
              closeSideBar();
            }}
            to={parentLink}
          >
            {menu.customIcon ? <i aria-hidden="true" className={`${menu.customIcon}  icon`}/> :
              <Icon name={menu.icon}/>}
            {menu.title}
          </Link>
        }
      };
    });


  return (

    <Sidebar
      as={Menu}
      animation='push'
      width='thin'
      visible={visible}
      icon='labeled'
      vertical={true}
      inverted={true}
    >
      <div className="logoHolder">
        <a href={mycdp_uri}>
          <img src={Logo} className="logo align-self-center" alt="Logo" />
        </a>
      </div>
      <Accordion className="leftMenu" panels={panels} defaultActiveIndex={basePathIndex} />
    </Sidebar>
  )
}
